import React from 'react';
import { Menu, Bell, Search, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

interface HeaderProps {
  onMenuToggle: () => void;
  title: string;
}

const Header: React.FC<HeaderProps> = ({ onMenuToggle, title }) => {
  const { user } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-30">
      <div className="flex items-center justify-between px-4 py-4 lg:px-6">
        {/* Left side */}
        <div className="flex items-center space-x-4">
          {/* Mobile menu button */}
          <button
            onClick={onMenuToggle}
            className="lg:hidden p-2 rounded-xl text-gray-600 hover:text-gray-900 hover:bg-brand-primary/10 transition-all duration-200 hover:shadow-md"
          >
            <Menu className="h-6 w-6" />
          </button>

          {/* Page title */}
          <div>
            <h1 className="text-xl font-bold text-gray-900">{title}</h1>
            <p className="text-sm text-gray-500">
              Bienvenue sur votre tableau de bord PHINLEX
            </p>
          </div>
        </div>

        {/* Right side */}
        <div className="flex items-center space-x-4">
          {/* Search */}
          <div className="hidden md:flex items-center space-x-2 bg-gray-100 rounded-xl px-4 py-2 hover:bg-gray-200 transition-colors">
            <Search className="h-4 w-4 text-gray-500" />
            <input
              type="text"
              placeholder="Rechercher..."
              className="bg-transparent border-none outline-none text-sm text-gray-700 placeholder-gray-500 w-48"
            />
          </div>

          {/* Notifications */}
          <button className="relative p-2 rounded-xl text-gray-600 hover:text-gray-900 hover:bg-brand-primary/10 transition-all duration-200 hover:shadow-md">
            <Bell className="h-5 w-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-brand-secondary rounded-full"></span>
          </button>

          {/* User menu */}
          <div className="flex items-center space-x-3">
            <div className="hidden md:block text-right">
              <p className="text-sm font-medium text-gray-900">{user?.fullName || user?.email}</p>
              <p className="text-xs text-gray-500">
                {user?.role?.name === 'training_center' ? 'Centre de Formation' : 'Professionnel du Pharma'}
              </p>
            </div>
            <div className="w-10 h-10 bg-gradient-to-br from-brand-primary/10 to-brand-accent/10 rounded-full flex items-center justify-center border-2 border-brand-primary/20 shadow-md">
              <span className="text-brand-primary font-semibold text-sm">
                {user?.fullName?.charAt(0).toUpperCase() || user?.email?.charAt(0).toUpperCase()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
